// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats_PLanP","stat":"Stats_stat_KvyBP","statName":"Stats_statName_TufTs","statValue":"Stats_statValue_btM0S"};